<template>
<div>
    <!-- Header -->
    <Header></Header>
    <br><br>
    <div class="container-fluid pb-3">
        <div class="row">
            <!-- Student Information Side -->
            <div class="bg-light border rounded-3 std-info-box1 col-lg-3">
                <h6 class="text-center mt-3"><b>Student Information</b></h6>

                <div v-if="loading" class="d-flex align-items-center justify-content-center gap-3 p-3 font-500">
                    <b-spinner></b-spinner> Loading...
                </div>
                <div class="student-info">
                    <label><b>ID</b></label>
                    <label class="text-right">{{ customerDetails.custom_user_id }}</label>
                </div>
                <div class="student-info">
                    <label><b>Email</b></label>
                    <input v-if="customerEditInfo" v-model="customerDetails.customer_name" class="input-field-StdInfo">
                    <label v-else class="text-right">{{ customerDetails.customer_name }}</label>
                </div>

                <div v-if="customerDetails.custom_extra_properties">
                    <div class="student-info" v-for="(value, key) in JSON.parse(customerDetails.custom_extra_properties)" :key="key">
                        <label><b>{{ key.charAt(0).toUpperCase() + key.slice(1) }}</b></label>
                        <input v-if="customerEditInfo" class="input-field-StdInfo" v-model="JSON.parse(customerDetails.custom_extra_properties)[key]" @change="changeonExtraProperties">
                        <label v-else class="text-right">{{ value }}</label>
                    </div>
                    <div class="edit-cancel-btn">
                        <div class="edit-btn">
                            <button v-if="!customerEditInfo" class="btn btn-outline-danger mt-5" @click="toggleCustomerEditInfo">Edit</button>
                            <button v-else class="btn btn-outline-danger" @click="cancelCustomerEditMode">Cancel</button>
                        </div>
                        <div>
                            <button type="submit" class="btn btn-outline-success" v-if="customerEditInfo" @click="customerEdit(customerDetails.name)">
                                <b-spinner v-if="loading" small> </b-spinner>Confirm
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Create Installments And Set Item Amounts Side -->
            <div v-if="invoiceId == null" class="col-lg-9 d-flex">
                <div class="bg-light border rounded-3 std-info-box1 d-flex col-lg-7 w-100" style="justify-content: space-around;">
                    <div style="width: 490px;">
                        <h6 class="text-center mt-3 mb-3"><b>Items Amount</b></h6>
                        <div v-if="loading" class="d-flex align-items-center justify-content-center gap-3 p-3 font-500">
                            <b-spinner></b-spinner> Loading...
                        </div>
                        <div v-if="!loading">
                            <div v-for="(item, index) in opportunityDetails.items" :key="item.name" class="student-info">
                                <div>
                                    <span>{{ item.item_name }}</span>
                                </div>
                                <div class="d-flex justify-content-between align-items-center">
                                    <div>
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" role="switch" :id="'freeCourse' + index" v-model="item.is_free_item" />
                                        </div>
                                    </div>
                                    <div v-if="!item.is_free_item">
                                        <span class="info-value">
                                            <input type="text" class="form-control course-amt-inputfield" v-model="item.amount">
                                        </span>
                                    </div>
                                    <div v-else>
                                        <datepicker :id="'dueDate' + index" class="form-control cal-date-installment" placeholder="Enter DueDate (required)" v-model="freeCourseDate" :disabled-dates="disabledDates"></datepicker>
                                    </div>
                                    <div class="ms-2 text-danger">
                                        <span><i class="fa-solid fa-trash" style="cursor: pointer;" @click="removeItem(index)"></i></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex align-items-center mt-3 mb-3">
                            <v-select v-if="items && opportunityDetails.items && items.length != opportunityDetails.items.length" v-model="selectedItems" :close-on-select="false" :options="filteredItems" label="item_name" :multiple="true" placeholder="Select Courses To Add" class="ms-2 w-50"></v-select>
                            <div>
                                <button v-if="selectedItems.length > 0" type="button" class="btn btn-outline-danger ms-2" style="border-radius: 30px;" @click="addItems()"><i class="fa-solid fa-arrow-up"></i></button>
                            </div>
                        </div>

                    </div>
                    <div class="mt-3 mb-3">
                        <hr width="2" style="margin: 0 auto;" class="bg-secondary h-100" />
                    </div>
                    <div style="width: 490px;">
                        <div class="d-flex ms-5 ps-5 mt-2">
                            <h6 v-if="!paymentDecision" class="ms-5"><b>Create Installments</b></h6>
                            <h6 v-else class="ms-5"><b>One Time Payment</b></h6>
                            <div class="ms-5 ps-5">
                                <div class="form-check form-switch">
                                    <input class="form-check-input" type="checkbox" role="switch" id="paymentDecision" v-model="paymentDecision" />
                                </div>
                            </div>
                        </div>
                        <h5 class="text-danger text-center"><strong>PKR {{ totalAmount }}</strong></h5>
                        <div v-if="!paymentDecision" v-for="(inputField, index) in inputFields" :key="index" class="mb-3 d-flex">
                            <br>
                            <datepicker :id="'dueDate' + index" v-model="inputField.dueDate" class="form-control cal-date-installment w-75" placeholder="Enter DueDate (required)" :disabled-dates="disabledDates"></datepicker>
                            <p class="mt-2 dash">-</p>
                            <input :id="'totalAmount' + index" v-model="inputField.totalAmount" @input="validateTotalAmount" type="text" class="form-control" placeholder="0">

                            <div class="ms-1 mt-1">
                                <button type="button" @click="deleteInputField(index)" class="btn btn-outline-danger inputfield" :disabled="inputFields.length == 1"><i class="fa-solid fa-trash"></i></button>
                            </div>
                        </div>
                        <div v-if="!paymentDecision" class="ms-1 mt-1">
                            <button type="button" @click="addInputField" class="btn btn-outline-success inputfield"><i class="fa-solid fa-plus"></i>Add Cycle</button>
                        </div>
                        <span v-if="amountExceeded" class="text-danger">Amount exceeds total {{ exceededAmount }}</span>
                        <div v-if="!paymentDecision" class="text-end mt-5">
                            <button :disabled="(amountExceeded || !allInputBoxesFilled || amountLess || loading || isSubmitDisabled)" type="submit" class="btn btn-outline-secondary me-2 mb-3" @click="createInvoice()">
                                <b-spinner v-if="loading" small> </b-spinner>Create Installment
                            </button>
                        </div>
                        <div v-else-if="paymentDecision" class="text-end mt-5">
                            <button :disabled="isSubmitDisabled" type="submit" class="btn btn-outline-secondary me-2 mb-3" @click="createInvoice()">
                                <b-spinner v-if="loading" small> </b-spinner>Create One Time
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Show Invoices Side -->
            <div v-else class="col-lg-9 d-flex">
                <div class="bg-light border rounded-3 std-info-box1 w-75 d-flex justify-content-between">
                    <div style="width: 60%;">
                        <h6 class="text-center mt-3"><b>Courses</b></h6>
                        <!-- {{getInstallmentsTotal}}
                        {{ getSelectedCourseTotal + totalAmountofFreezedCourse }} -->
                        <div v-if="loading" class="d-flex align-items-center justify-content-center gap-3 p-3 font-500">
                            <b-spinner></b-spinner> Loading...
                        </div>
                        
                        <table class="table table-striped" v-else-if="invoice && invoice.items && invoice.items.length > 0">
                            <thead>
                                <tr>
                                    <th>Course</th>
                                    <th>Amount</th>
                                    <th v-if="!isInvoiceEdit">Paid</th>
                                    <th v-if="isInvoiceEdit"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item,index) in invoice.items" :key="item.name">
                                    <td>
                                        {{ item.item_name }}
                                        <b-badge pill v-bind:class="getStatusVariant(courseStatus(item.item_code))">{{ courseStatus(item.item_code) }}</b-badge>
                                    </td>
                                    <td>
                                        <div v-if="!isInvoiceEdit">
                                            <div v-if="item.is_free_item !== 1">
                                                {{ item.amount }}
                                            </div>
                                            <div v-else>
                                                <b-badge pill variant="success" class="bg-success text-white">Free</b-badge>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <input v-if="item.is_free_item !== 1 && !item.is_free_item" v-model="item.amount" class="w-100 input-field-StdInfo" :readonly="item.amount === paidAndRemainingAmountOfCourse(item.item_code)" />
                                            <div v-else-if="(item.is_free_item == 1 || item.is_free_item == true)">
                                                <datepicker :id="'dueDate' + index" class="form-control cal-date-installment" placeholder="Enter DueDate (required)" v-model="item.custom_due_date" :disabled-dates="disabledDates"></datepicker>
                                            </div>
                                            <b-badge v-else pill variant="success" class="bg-success text-white">Free</b-badge>
                                        </div>
                                    </td>
                                    <td v-if="!isInvoiceEdit">
                                        {{ paidAndRemainingAmountOfCourse(item.item_code) }}<br>
                                    </td>
                                    <td v-if="isInvoiceEdit">
                                        <div class="d-flex ms-auto align-items-center">
                                            <a data-bs-toggle="dropdown" id="options-dropdown-btn" class="category-options dropdown-toggle" role="button"><i class="fa-solid fa-ellipsis-vertical"></i>
                                            </a>
                                            <ul id="options-dropdown" class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuLink">
                                                <li class="options-dropdown-item">
                                                    <span class="text-success" v-if="invoice.items[index].is_free_item == 0">Mark as Free</span>
                                                    <span class="text-danger" v-if="invoice.items[index].is_free_item == 1">Remove as free</span>
                                                    <div v-if="isInvoiceEdit && item.amount !== paidAndRemainingAmountOfCourse(item.item_code)" class="form-check form-switch">
                                                        <input class="form-check-input" type="checkbox" role="switch" :id="'is_free_item' + index" v-model="invoice.items[index].is_free_item" />
                                                    </div>
                                                </li>
                                                <li>
                                                    <hr class="dropdown-divider" />
                                                </li>
                                                <li v-if="paidAndRemainingAmountOfCourse(item.item_code) == 0" @click="removeandeditItem(index)" class="options-dropdown-item delete">
                                                    <span class="text-danger">Delete</span>
                                                    <div class="text-danger" v-if="isInvoiceEdit && item.amount !== paidAndRemainingAmountOfCourse(item.item_code)">
                                                        <span><i class="fa-solid fa-trash" style="cursor: pointer;"></i></span>
                                                    </div>
                                                </li>
                                                <li>
                                                    <hr class="dropdown-divider" />
                                                </li>
                                                <li class="options-dropdown-item">
                                                    <span class="text-warning">Freeze Course</span>
                                                    <div class="text-warning">
                                                        <i class="fa-solid fa-circle-stop"></i>
                                                    </div>
                                                </li>
                                                <li>
                                                    <hr class="dropdown-divider" />
                                                </li>
                                                <li class="options-dropdown-item">
                                                    <span class="text-primary">Refund</span>
                                                    <div class="text-primary">
                                                        <i class="fa-solid fa-cash-register"></i>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <br>
                        </table>
                        <div v-if="isInvoiceEdit" class="mb-2 w-75 align-items-center ms-4">
                            <v-select v-if="invoice && invoice.items && invoice.items.length > 0" v-model="selectedItems" :close-on-select="false" :options="filteredEditableItems" label="item_name" placeholder="Enter Courses" multiple></v-select>
                            <div>
                                <button v-if="selectedItems.length > 0" type="button" class="btn btn-outline-danger" style="border-radius: 30px;" @click="addandeditItems()"><i class="fa-solid fa-arrow-up"></i></button>
                            </div>
                        </div>
                        <div class="text-center mb-2">
                            <button type="button" class="btn btn-outline-success" @click="openTransferModal()">Transfer Course</button>
                        </div>
                        <div class="text-center mb-2">
                            <button type="button" class="btn btn-outline-success" @click="openFreezeModal()">Freeze Course</button>
                        </div>
                        <div class="text-center mb-2" v-if="checkFreezeStatusLength > 0">
                            <button type="button" class="btn btn-outline-success" @click="openUnfreezeModal()">UnFreeze Course</button>
                        </div>
                        <div v-if="checkFreezeStatusLength > 0">
                            <hr />
                            <h5 class="text-center"><strong>Freezed Courses</strong></h5>
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th>Course</th>
                                        <th>Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(freeze, index) in invoicePaymentDetail" :key="freeze.name">
                                        <td v-if="freeze.status === 'Freeze'">{{ freeze.itemid }}</td>
                                        <td v-if="freeze.status === 'Freeze'">{{ freeze.amount }}</td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>

                    <div class="mt-3 mb-3">
                        <hr width="2" style="margin: 0 auto;" class="bg-secondary h-100" />
                    </div>
                    <div style="width: 55%;">
                        <h6 class="text-center mt-3"><b>Installments</b></h6>
                        <div v-if="loading" class="d-flex align-items-center justify-content-center gap-3 p-3 font-500">
                            <b-spinner></b-spinner> Loading...
                        </div>
                        <table class="table table-striped" v-else-if="invoice && invoice.payment_schedule && invoice.payment_schedule.length > 0">
                            <thead>
                                <tr>
                                    <th>Due Date</th>
                                    <th>Amount</th>
                                    <th v-if="!isInvoiceEdit">Status</th>
                                    <th v-if="isInvoiceEdit"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(invoice,index) in invoice.payment_schedule" :key="invoice.name">
                                    <td>
                                        <div v-if="isInvoiceEdit && getInstallmentStatus(index) === 'Unpaid'">
                                            <datepicker v-model="invoice.due_date" format="yyyy-MM-dd" :disabled-dates="disabledDates" class="w-50" />
                                        </div>
                                        <div v-else>
                                            <span>{{ formattedDate(invoice.due_date) }}</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div v-if="isInvoiceEdit && getInstallmentStatus(index) === 'Unpaid'">
                                            <input v-model="invoice.payment_amount" class="input-field-StdInfo w-100" />
                                        </div>
                                        <div v-else>
                                            <span>{{ invoice.payment_amount }}</span>
                                        </div>
                                    </td>
                                    <td v-if="!isInvoiceEdit">
                                        <b-badge pill :variant="getInstallmentStatus(index) === 'Paid' ? 'success' : (getInstallmentStatus(index) === 'Partly Paid' ? 'warning' : 'danger')" :class="{ 'text-success': getInstallmentStatus(index) === 'Paid', 'text-warning': getInstallmentStatus(index) === 'Partly Paid', 'text-danger': getInstallmentStatus(index) === 'Unpaid' }">
                                            {{ getInstallmentStatus(index) }}
                                        </b-badge>
                                    </td>
                                    <td v-if="isInvoiceEdit && getInstallmentStatus(index) === 'Unpaid'">
                                        <div class="text-danger">
                                            <span><i class="fa-solid fa-trash" style="cursor: pointer;" @click="removeEditCycles(index)"></i></span>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <br>
                            <div v-if="isInvoiceEdit" class="ms-3 mb-2">
                                <button type="button" @click="addEditInstallmentsCycle" class="btn btn-outline-success inputfield">Add Cycle</button>
                            </div>
                            <div class="button-main-div">
                                <div class="mx-3">
                                    <button v-if="!isInvoiceEdit" class="btn btn-outline-danger" @click="toggleInvoiceEdit">Edit</button>
                                    <button v-else class="btn btn-outline-danger" @click="cancelInvoiceEdit()">Cancel</button>
                                </div>
                                <div>
                                    <button type="button" class="btn btn-outline-success" v-if="isInvoiceEdit == true" @click="invoiceEdit()" :disabled="getSelectedCourseTotal + totalAmountofFreezedCourse != getInstallmentsTotal">
                                        <b-spinner v-if="loading" small> </b-spinner>
                                        Confirm
                                    </button>
                                </div>
                            </div>
                        </table>

                    </div>
                </div>
                <div class="bg-light border rounded-3 std-info-box1 w-50 ms-2">
                    <div>
                        <h6 class="text-center mt-3"><b>Payment</b></h6>
                        <div v-if="loading" class="d-flex align-items-center justify-content-center gap-3 p-3 font-500">
                            <b-spinner></b-spinner> Loading...
                        </div>
                        <table v-else-if="invoicePayment && invoicePayment && invoicePayment.length > 0" class="table table-striped">
                            <thead>
                                <tr>
                                    <th>Mode</th>
                                    <th>Paid Amount</th>
                                    <th>Posting Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="clickable-row" v-for="(payment,index) in invoicePayment" :key="payment.name" @click="openPaymentDetailModal(payment.name)">
                                    <td>
                                        {{ payment.mode_of_payment }}
                                    </td>
                                    <td>
                                        {{ payment.paid_amount }}
                                    </td>
                                    <td>{{ formattedDate(payment.posting_date) }}</td>

                                </tr>
                            </tbody>
                            <br>
                        </table>

                        <div v-else class="text-danger text-center">No Payments Found</div>
                        <div class="text-end me-2 mb-2">
                            <a data-bs-toggle="dropdown" id="options-dropdown-btn" class="dropdown-toggle btn btn-outline-secondary" role="button" :disabled="!isPaymentAllowed">Make Payment
                                <ul id="options-dropdown" class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuLink">
                                    <li v-for="(mode, index) in modesOfPayments" :key="mode.name" class="options-dropdown-item text-success" @click="openAttachmentModal(unpaidAmount,mode.name)">
                                        {{ mode.name }}
                                    </li>
                                </ul>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Make Payments Modal -->    
    <AttachmentModal :unpaidAmount="unpaidAmount" :oldestDueDate="oldestDueDate" :invoiceId="invoiceId" :customerName="customerName" :invoice="invoice" :invoicePaymentDetail="invoicePaymentDetail" @getData="getPaymentByInvoice" :paymentMode="paymentMode" :userId="userId" />
    <!-- Show Payment Details Modal -->
    <PaymentDetailModal :paymentId="paymentId" :showPaymentDetailModal="showPaymentDetailModal" @updatepaymentDetailModal="updatepaymentDetailModal" :items="items" />
    <TransferModal :invoice="invoice" :invoicePaymentDetail="invoicePaymentDetail" :items="items" :invoiceId="invoiceId" :customerName="customerName" :userId="userId" :oldestDueDate="oldestDueDate"/>
    <FreezeModal :invoice="invoice" :invoicePaymentDetail="invoicePaymentDetail" :items="items" :invoiceId="invoiceId" :customerName="customerName" :userId="userId" />
    <UnfreezeModal :invoice="invoice" :invoicePaymentDetail="invoicePaymentDetail" :items="items" :invoiceId="invoiceId" :customerName="customerName" :userId="userId" :oldestDueDate="oldestDueDate"/>
    <!-- Footer -->
    <Footer></Footer>
</div>
</template>

<script>
import Header from '../components/Layout/Header.vue';
import Footer from '../components/Layout/Footer.vue';
import AttachmentModal from '../components/Layout/AttachmentModal.vue';
import Datepicker from 'vuejs-datepicker';
import PaymentDetailModal from './Layout/PaymentDetailModal.vue';
import * as invoiceHelper from '../store/invoiceHelper';
import * as LmsApiHelper from '../store/LmsApiHelper';
import FreezeModal from './Layout/FreezeModal.vue';
import UnfreezeModal from './Layout/UnfreezeModal.vue';
import {
    mapState
} from 'vuex';
import TransferModal from './Layout/TransferModal.vue';
export default {
    name: 'StudentInformation',
    data() {
        return {
            leadId: this.$route.query.leadId,
            customerName: null,
            customerDetails: [],
            customerEditInfo: false,
            opportunityDetails: [],
            inputFields: [{
                dueDate: null,
                totalAmount: null
            }],
            selectedNumber: 0,
            amountExceeded: false,
            exceededAmount: 0,
            amountLess: false,
            allInputBoxesFilled: false,
            loading: false,
            items: [],
            selectedItems: [],
            invoice: {},
            freeCourse: false,
            paymentDecision: false,
            freeCourseDate: null,
            invoiceId: this.$route.query.invoice,
            isInvoiceEdit: false,
            paymentAmount: 0,
            status: null,
            payment: [],
            invoicePayment: [],
            paymentId: null,
            showPaymentDetailModal: false,
            invoicePaymentDetail: [],
            isDropdownOpen: false,
            paymentMode: '',
            modesOfPayments: [],
            userId: ''
        };
    },
    components: {
        Header,
        Footer,
        Datepicker,
        AttachmentModal,
        PaymentDetailModal,
        TransferModal,
        FreezeModal,
        UnfreezeModal
    },
    methods: {
        async getCustomer() {
            try {
                this.loading = true;
                const customerResponse = await fetch(`${this.erp_api_url}api/resource/Customer/${this.customerName}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `${this.authorization_token}`
                    },
                });
                const customer = await customerResponse.json();
                this.customerDetails = customer.data;
                this.userId = customer.data.custom_user_id;
            } catch (error) {
                console.error('Error fetching leads:', error);
            } finally {
                this.loading = false;
            }
        },
        async getOpportunity() {
            try {
                this.loading = true;
                const opportunityResponse = await fetch(`${this.erp_api_url}api/resource/Opportunity/${this.leadId}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `${this.authorization_token}`
                    },
                });
                const opportunity = await opportunityResponse.json();
                this.opportunityDetails = opportunity.data;
                this.customerName = opportunity.data.customer_name;
                await this.getCustomer();
            } catch (error) {
                console.error('Error fetching leads:', error);
            } finally {
                this.loading = false;
            }
        },
        toggleCustomerEditInfo() {
            this.customerEditInfo = !this.customerEditInfo;
        },
        cancelCustomerEditMode() {
            this.customerEditInfo = false;
        },
        toggleInvoiceEdit() {
            this.isInvoiceEdit = !this.isInvoiceEdit;
        },
        cancelInvoiceEdit() {
            this.isInvoiceEdit = false;
        },
        validateTotalAmount() {
            const totalEnteredAmount = this.inputFields.reduce((total, inputField) => {
                return total + parseFloat(inputField.totalAmount) || 0;
            }, 0);
            this.exceededAmount = Math.max(0, totalEnteredAmount - this.totalAmount);
            this.amountExceeded = totalEnteredAmount > this.totalAmount;
            this.amountLess = totalEnteredAmount < this.totalAmount;
            this.allInputBoxesFilled = this.inputFields.every(inputField => inputField.dueDate && inputField.totalAmount);
            if (totalEnteredAmount === this.totalAmount) {
                this.amountExceeded = false;
            }
        },
        async fetchAllItems() {
            try {
                const response = await fetch(this.erp_api_url + 'api/resource/Item?fields=["*"]', {
                    method: 'GET',
                    headers: {
                        'Authorization': `${this.authorization_token}`
                    },
                });
                const items = await response.json();
                this.items = items.data;
            } catch (error) {
                console.error('Error fetching courses:', error);
            }
        },
        addItems() {
            this.selectedItems.forEach((item) => {
                this.opportunityDetails.items.push(item);
            });
            this.selectedItems = [];
        },
        addandeditItems() {
            this.selectedItems.forEach((item) => {
                this.invoice.items.push(item);
            });
            this.selectedItems = [];
        },
        removeItem(index) {
            if (index > -1) {
                this.opportunityDetails.items.splice(index, 1);
            }
        },
        removeandeditItem(index) {
            if (index > -1) {
                this.invoice.items.splice(index, 1);
            }
        },
        removeEditCycles(index) {
            if (index > -1) {
                this.invoice.payment_schedule.splice(index, 1);
            }
        },
        addInputField() {
            this.inputFields.push({
                dueDate: null,
                totalAmount: null
            });
        },
        deleteInputField(index) {
            this.inputFields.splice(index, 1);
        },
        async createInvoice() {
            try {
                this.loading = true;
                const selectedItem = this.opportunityDetails.items.map(item => {
                    const newItem = {
                        item_code: item.item_code,
                        qty: 1,
                        is_free_item: item.is_free_item === true ? 1 : 0
                    };
                    if (!item.is_free_item) {
                        newItem.rate = parseFloat(item.amount);
                    }
                    if (item.is_free_item) {
                        newItem.custom_due_date = new Date(this.freeCourseDate).toISOString().split('T')[0];
                    }
                    return newItem;
                });
                const freeItems = selectedItem.filter(item => item.is_free_item);
                console.log("Free Items:", freeItems);
                for (let i = 0; i < freeItems.length; i++) {
                    const item_pv_id = await invoiceHelper.getItemByItemName(freeItems[i].item_code);
                    console.log(item_pv_id);
                    const response = await LmsApiHelper.courseAccess(this.userId, item_pv_id.custom_product_variant_id, freeItems[i].custom_due_date);
                    if(response === 401){
                    this.$toasted.error("You are already logged in.", {
            theme: "outline",
            duration: 3000,
            icon: "exclamation-triangle",
            position: "bottom-center",
        });
                    localStorage.clear();
                    this.$router.push('/login');
                    return;
                }
                }
                const paymentPlan = this.inputFields.map(payment => ({
                    due_date: parseFloat(payment.totalAmount) ? new Date(payment.dueDate).toISOString().split('T')[0] : new Date().toISOString().split('T')[0],
                    payment_amount: parseFloat(payment.totalAmount) ? parseFloat(payment.totalAmount) : this.totalAmount
                }));
                const invoiceData = {
                    doctype: "Sales Invoice",
                    customer: this.customerDetails.name,
                    "posting_date": "2023-12-21",
                    items: selectedItem,
                    payment_schedule: paymentPlan,
                    company: this.customerDetails.company,
                    currency: this.customerDetails.currency,
                    "due_date": "2024-12-31",
                    "docstatus": "1"
                };
                const response = await invoiceHelper.addInvoice(invoiceData);
                if (response && response.data != null) {
                    const message = "Invoice Created SuccessFully!";
                    this.$toasted.success(
                        `${message} !`, {
                            theme: "outline",
                            position: "bottom-center",
                            duration: 3000,
                        }
                    );
                    await this.convertStatus();
                    this.$router.push('/Invoices');
                } else {
                    this.$toasted.error("Invalid Data", {
                        theme: "outline",
                        duration: 3000,
                        icon: "exclamation-triangle",
                        position: "bottom-center",
                    });
                }
            } catch (error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        },
        async getInvoice() {

            try {
                this.loading = true;
                const invoicesResponse = await fetch(`${this.erp_api_url}api/resource/Sales Invoice/${this.invoiceId}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `${this.authorization_token}`
                    },
                })
                const invoice = await invoicesResponse.json();
                this.invoice = invoice.data;
                this.customerName = invoice.data.customer_name;

                if (this.invoice && this.invoice.payment_schedule && this.invoice.payment_schedule.length) {
                    this.invoice.payment_schedule.sort((a, b) => {
                        return new Date(a.due_date) - new Date(b.due_date);
                    });
                }
                await this.getCustomer();
            } catch (error) {
                console.error('Error fetching courses:', error);
            } finally {
                this.loading = false;
            }
        },
        async convertStatus() {
            try {
                const status = await fetch(`${this.erp_api_url}api/resource/Opportunity/${this.leadId}`, {
                    method: 'PUT',
                    headers: {
                        'Authorization': `${this.authorization_token}`,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        "status": "Converted"
                    }),
                });
                if (status.ok) {} else {
                    console.error('Failed to update status. Server returned:', status.status, status.statusText);
                }
            } catch (error) {
                console.error('Error fetching courses:', error);
            }
        },
        async getPayment() {
            try {
                const response = await fetch(`${this.erp_api_url}api/resource/Payment%20Entry?fields=["name","owner","creation","modified","modified_by","payment_type","company","party_type","party_name","paid_from_account_currency","paid_amount","status","remarks"]`, {
                    method: 'GET',
                    'Authorization': `${this.authorization_token}`
                });
                const payment = response.json();
                this.payment = payment.data;
                if (this.payment && this.payment.length) {
                    this.payment.filter()
                }
            } catch (error) {
                console.error("Error fetching payment");
            }
        },
        openAttachmentModal(unpaidAmount, paymentMethod) {
            console.log(paymentMethod);
            this.paymentMode = paymentMethod;
            $('#exampleModalCenter').modal('show');
        },
        async getPaymentByInvoice() {
            try {
                this.loading = true;
                const response = await fetch(
                    `${this.erp_api_url}api/resource/Payment%20Entry?fields=["*"]&filters=[["Payment Entry Reference", "reference_name","=","${this.invoiceId}"]]`, {
                        method: 'GET',
                        headers: {
                            'Authorization': `${this.authorization_token}`
                        }
                    }
                );
                const invoicePayment = await response.json();
                this.invoicePayment = invoicePayment.data;
                await this.getPaymentDetailByInvoiceId();
            } catch (error) {
                console.error("Error fetching payment");
            } finally {
                this.loading = false;
            }
        },
        getInstallmentStatus(index) {
            var payment = 0;
            const totalAllocatedAmount = this.getTotalPaid;
            for (let i = 0; i <= index; i++) {
                payment += this.invoice.payment_schedule[i].payment_amount
            }

            if (totalAllocatedAmount >= payment) {
                return 'Paid';
            } else {
                return 'Unpaid';
            }
        },
        openPaymentDetailModal(paymentId) {
            this.paymentId = paymentId;
            this.showPaymentDetailModal = true;
            $('#paymentDetail').modal('show');
        },
        updatepaymentDetailModal() {
            this.showPaymentDetailModal = !this.showPaymentDetailModal;
            $('#paymentDetail').modal('hide');
        },
        async customerEdit(customerId) {
            try {
                this.loading = true;
                const customExtraProperties = JSON.parse(this.customerDetails.custom_extra_properties || '{}');

                const payload = {
                    customer_name: this.customerDetails.customer_name,
                    custom_extra_properties: JSON.stringify(customExtraProperties),
                };

                const response = await fetch(`${this.erp_api_url}api/resource/Customer/${customerId}`, {
                    method: 'PUT',
                    headers: {
                        'Authorization': `${this.authorization_token}`
                    },
                    body: JSON.stringify(payload),
                });

                const editCustomerResponse = await response.json();

                if (editCustomerResponse != null) {
                    this.customerEditInfo = false;
                    this.getCustomer();
                }
            } catch (error) {
                console.log("Error While Editing Customer");
            } finally {
                this.loading = false;
            }
        },
        async invoiceEdit() {
    console.log("hello");

    const payment_schedule = this.invoice.payment_schedule.map(invoice => ({
        due_date: parseFloat(invoice.payment_amount) ? new Date(invoice.due_date).toISOString().split('T')[0] : new Date().toISOString().split('T')[0],
        payment_amount: parseFloat(invoice.payment_amount) ? parseFloat(invoice.payment_amount) : this.totalAmount
    }));

    const editItemAmount = this.invoice.items.map(async item => {
        const newItem = {
            item_code: item.item_code,
            qty: 1,
            is_free_item: item.is_free_item === true || item.is_free_item === 1 ? 1 : 0,
        };

        if (!item.is_free_item) {
            newItem.rate = parseFloat(item.amount);
        }
        if (item.is_free_item) {
            newItem.custom_due_date = new Date(item.custom_due_date).toISOString().split('T')[0];
        }

        if (newItem.is_free_item !== item.is_free_item) {
            console.log("Changed is_free_item for item_code", item.item_code, "to", newItem.is_free_item);
            console.log(newItem);

            try {
                if (newItem.is_free_item === 0) {
                    const item_pv_id = await invoiceHelper.getItemByItemName(newItem.item_code);
                    const response = await LmsApiHelper.invokedAccess(this.userId, item_pv_id.custom_product_variant_id, "Unenrolled");
                    if (response === 401) {
                        this.$toasted.error("You are already logged in.", {
                            theme: "outline",
                            duration: 3000,
                            icon: "exclamation-triangle",
                            position: "bottom-center",
                        });
                        localStorage.clear();
                        this.$router.push('/login');
                        return;
                    }
                } else if (newItem.is_free_item === 1) {
                    const item_pv_id = await invoiceHelper.getItemByItemName(newItem.item_code);
                    const response = await LmsApiHelper.courseAccess(this.userId, item_pv_id.custom_product_variant_id, newItem.custom_due_date);
                    if (response === 401) {
                        this.$toasted.error("You are already logged in.", {
                            theme: "outline",
                            duration: 3000,
                            icon: "exclamation-triangle",
                            position: "bottom-center",
                        });
                        localStorage.clear();
                        this.$router.push('/login');
                        return;
                    }
                }
            } catch (error) {
                console.error("Error handling item access:", error);
                throw error; // Ensure any error stops the execution
            }
        }

        return newItem;
    });

    try {
        this.loading = true;

        // Wait for all editItemAmount promises to resolve
        const resolvedEditItems = await Promise.all(editItemAmount);

        const EditInvoiceData = {
            name: this.invoiceId,
            customer: this.customerName,
            posting_date: new Date().toISOString().split('T')[0],
            items: resolvedEditItems,
            payment_schedule: payment_schedule
        };

        // Only proceed with the invoice edit if all previous operations succeeded
        const response = await fetch(`${this.erp_api_url}api/resource/Sales%20Invoice`, {
            method: 'POST',
            headers: {
                'Authorization': `${this.authorization_token}`
            },
            body: JSON.stringify(EditInvoiceData)
        });

        const editinvoiceResponse = await response.json();
        if (editinvoiceResponse && editinvoiceResponse.data != null) {
            await invoiceHelper.editInvoiceStatus(editinvoiceResponse.data.name, 1);
            const getPayment = await invoiceHelper.getPaymentByInvoice(this.invoiceId);
            console.log(getPayment);
            const getPaymentDetail = await invoiceHelper.getPaymentDetailByInvoiceId(this.invoiceId);
            await invoiceHelper.editInvoiceStatus(this.invoiceId, 2);
            this.isInvoiceEdit = false;

            this.invoiceId = editinvoiceResponse.data.name;
            for (let i = 0; i < this.invoicePayment.length; i++) {
                await invoiceHelper.editPayments(this.invoiceId, this.invoicePayment[i].name, this.invoicePayment[i].paid_amount, this.invoicePayment[i].mode_of_payment);
                for (let j = 0; j < this.invoicePaymentDetail.length; j++) {
                    await invoiceHelper.editPaymentDetails(this.invoiceId, this.invoicePaymentDetail[j].name);
                }
            }

            this.$router.push({
                name: "StudentInformation",
                query: {
                    invoice: editinvoiceResponse.data.name
                },
                path: '/Student/information'
            });
        }
    } catch (error) {
        console.error("Error Editing Invoice", error);
    } finally {
        this.loading = false;
    }
},

        async getPaymentDetailByInvoiceId() {
            try {
                const response = await fetch(`${this.erp_api_url}api/resource/PaymentDetail?fields=["*"]&filters=[["invoiceid", "=", "${this.invoiceId}"]]`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `${this.authorization_token}`
                    },
                });
                const paymentDetails = await response.json();
                this.invoicePaymentDetail = paymentDetails.data;
            } catch (error) {
                console.error("Error While Fetching Payments Detail", error);
            }
        },
        async editPayments(invoiceId, paymentId, paidAmount, paymentMode) {
            const editPaymentData = {
                references: [{
                    "reference_doctype": "Sales Invoice",
                    reference_name: invoiceId,
                    allocated_amount: parseFloat(paidAmount)
                }],
                mode_of_payment: paymentMode,
                received_amount: parseFloat(paidAmount),
                paid_amount: parseFloat(paidAmount),
                paid_to: `${paymentMode} - TCD`,
                paid_to_account_currency: "PKR"
            };
            try {
                const response = await fetch(`${this.erp_api_url}api/resource/Payment%20Entry/${paymentId}`, {
                    method: 'PUT',
                    headers: {
                        'Authorization': `${this.authorization_token}`
                    },
                    body: JSON.stringify(editPaymentData)
                })
            } catch (error) {
                console.error("Error While Editing Payments", error);
            }
        },
        async editPaymentDetails(invoiceId, paymentDetailId) {
            const editPaymentData = {
                "invoiceid": invoiceId
            };

            try {
                const response = await fetch(`${this.erp_api_url}api/resource/PaymentDetail/${paymentDetailId}`, {
                    method: 'PUT',
                    headers: {
                        'Authorization': `${this.authorization_token}`
                    },
                    body: JSON.stringify(editPaymentData)
                })
            } catch (error) {
                console.error("Error While Editing Payments", error);
            }
        },
        paidAndRemainingAmountOfCourse(itemid) {
            const matchingItems = this.invoicePaymentDetail.filter(item => item.itemid === itemid);
            if (matchingItems.length > 0) {
                const totalAmount = matchingItems.reduce((sum, item) => sum + parseFloat(item.amount), 0);
                return totalAmount;
            } else {
                return 0;
            }
        },
        courseStatus(itemid) {
            const matchingItems = this.invoicePaymentDetail.filter(item => item.itemid === itemid);
            const nonPaymentItems = matchingItems.filter(item => item.status !== "Payment");
            if (nonPaymentItems.length > 0) {
                return nonPaymentItems[0].status;
            } else {
                return null;
            }
        },
        getStatusVariant(status) {
            switch (status) {
                case 'Freeze':
                    return 'bg-success text-white';
                case 'TransferOut':
                    return 'bg-danger text-white';
            }
        },
        addEditInstallmentsCycle() {
            this.invoice.payment_schedule.push({
                due_date: new Date().toISOString().split('T')[0],
                payment_amount: 0
            });
        },
        formattedDate(dateString) {
            const options = {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            };
            const formattedDate = new Date(dateString).toLocaleDateString('en-US', options);
            return formattedDate;
        },
        openTransferModal() {
            $('#transferModal').modal('show');
        },
        openFreezeModal() {
            $('#freezeModal').modal('show');
        },
        openUnfreezeModal() {
            $('#unfreezeModal').modal('show');
        },
        changeonExtraProperties(e) {
            console.log(e);
        },
    },
    async mounted() {
        this.getPaymentByInvoice();
        if (this.leadId && this.leadId != null) {
            this.getOpportunity();
        }
        this.fetchAllItems();
        if (this.invoiceId != null) {
            this.getInvoice();
        }
        const modes = await invoiceHelper.getModesOfPayment();
        this.modesOfPayments = modes.data;
    },
    computed: {
        ...mapState(["erp_api_url","authorization_token"]),
        isPaymentAllowed() {
            return this.unpaidAmount > 0;
        },
        unpaidAmount() {
            if (this.invoice && this.invoice.payment_schedule && this.invoice.payment_schedule.length > 0) {
                const unpaidAndPartlyPaid = this.invoice.payment_schedule.filter(invoice => {
                    const status = this.getInstallmentStatus(this.invoice.payment_schedule.indexOf(invoice));
                    return status === 'Unpaid' || status === 'Partly Paid';
                });

                if (unpaidAndPartlyPaid.length > 0) {
                    const oldestDueDateEntry = unpaidAndPartlyPaid.reduce((oldest, invoice) => {
                        return new Date(invoice.due_date) < new Date(oldest.due_date) ? invoice : oldest;
                    });
                    return oldestDueDateEntry.payment_amount;
                }
            }
            return 0;
        },
        oldestDueDate() {
            if (this.invoice && this.invoice.payment_schedule && this.invoice.payment_schedule.length > 0) {
                const unpaidAndPartlyPaid = this.invoice.payment_schedule.filter(invoice => {
                    const status = this.getInstallmentStatus(this.invoice.payment_schedule.indexOf(invoice));
                    return status === 'Unpaid' || status === 'Partly Paid';
                });

                if (unpaidAndPartlyPaid.length > 0) {
                    const oldestDueDateEntry = unpaidAndPartlyPaid.reduce((oldest, invoice) => {
                        return new Date(invoice.due_date) < new Date(oldest.due_date) ? invoice : oldest;
                    });

                    let nextdate = new Date(oldestDueDateEntry.due_date);

                    for (let i = 0; i < unpaidAndPartlyPaid.length; i++) {
                        const currentDate = new Date(unpaidAndPartlyPaid[i].due_date);
                        if (currentDate > nextdate) {
                            nextdate = currentDate;
                            break;
                        }
                    }

                    return nextdate.toString();
                }
            }
            return null;
        },

        getTotalPaid() {
            return this.invoicePayment.reduce((total, payment) => {
                return total + payment.paid_amount;
            }, 0);
        },
        getSelectedCourseTotal() {
            if (this.invoice.items && this.invoice.items.length) {
                return this.invoice.items
                    .filter(item => item.is_free_item !== 1 && !item.is_free_item)
                    .reduce((total, invoiceItem) => {
                        const itemPaidAmount = this.paidAndRemainingAmountOfCourse(invoiceItem.item_code);

                        return total + parseFloat(invoiceItem.amount) - itemPaidAmount;
                    }, 0);
            }
            return 0;
        },
        getInstallmentsTotal() {
            if (this.invoice.payment_schedule && this.invoice.payment_schedule.length) {
                return this.invoice.payment_schedule.reduce((total, installmentAmount, index) => {
                    if (this.getInstallmentStatus(index) != 'Paid') {
                        return total + parseFloat(installmentAmount.payment_amount);
                    }
                    return 0;
                }, 0)
            }
            return 0;
        },
        isSubmitDisabled() {
            return this.opportunityDetails.items.some(item => isNaN(parseFloat(item.amount)) || item.amount === '' || item.amount == 0) && this.freeCourseDate == null;
        },
        disabledDates() {
            const minDate = new Date();
            minDate.setDate(minDate.getDate() - 1);

            return {
                to: minDate
            };
        },
        filteredItems() {
            console.log(this.items);
            return this.items.filter(item => {
                item.item_code = item.name;
                return !this.opportunityDetails.items.some(opportunityItem => opportunityItem.item_name === item.item_name)
            });
        },
        filteredEditableItems() {
            return this.items.filter(item => {
                item.item_code = item.name;
                return !this.invoice.items.some(invoiceItem => invoiceItem.item_name === item.item_name)
            });
        },

        totalAmount() {
            if (this.opportunityDetails.items && this.opportunityDetails.items.length > 0) {
                return this.opportunityDetails.items.reduce((acc, item) => acc + parseFloat(item.amount), 0);
            }
            return 0;
        },
        checkFreezeStatusLength() {
            const itemsWithStatus = this.invoicePaymentDetail.filter(x => x.status === "Freeze");
            return itemsWithStatus.length;
        },
        totalAmountofFreezedCourse() {
            const freezeItems = this.invoicePaymentDetail.filter(freeze => freeze.status === 'Freeze');
            const totalAmount = freezeItems.reduce((sum, freeze) => sum + parseFloat(freeze.amount), 0);
            return totalAmount;
        }
    }
};
</script>

<style scoped>
.student-info {
    display: flex;
    justify-content: space-between;
    padding: 0px 15px;
    margin-bottom: 5px;
}

.course-amt-inputfield {
    width: 208px;
}

.edit-cancel-btn {
    margin: 10px 15px;
    display: flex;
    justify-content: space-between;
}

.button-main-div {
    display: flex;
    justify-content: space-between;
}

.input-field-StdInfo {
    padding: 2px 8px;
    border-radius: 7px;
    margin-bottom: 5px;
    border: 1px solid #dcd8d8;
}

.dash {
    padding: 0 1rem;
}

.inputfield {
    border-radius: 20px;
}

.clickable-row {
    cursor: pointer;
}

.category-options {
    width: 1.875rem;
    height: 1.875rem;
    background: #ebebeb;
    border-radius: 50%;
    display: flex !important;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-left: auto;
    text-decoration: none;
    color: black;
}

.category-options::after {
    display: none !important;
}

.options-dropdown-item {
    padding: 0.75rem 1rem;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    color: #000000;
    column-gap: 0.75rem;
}

.options-dropdown-item:hover {
    background-color: #ebebeb;
}

.options-dropdown-item.delete {
    color: #ff0000;
}

#options-dropdown .dropdown-divider {
    margin: 0 !important;
    color: #ebebeb;
}
</style>
